import { CommonModule } from '@angular/common';
import { InjectionToken, Inject, Component, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AnalyticsService } from 'ngx-shared-services';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'ngx-shared-services';
import * as ɵngcc2 from '@ngx-translate/core';

const _c0 = function (a0) { return { currentYear: a0 }; };
const _c1 = function (a0, a1) { return { "email": a0, "phone": a1 }; };
const NAMESPACE_TOKEN = new InjectionToken('NamespaceToken');
class GlobalFooterComponent {
    constructor(analytics, _namespace = '') {
        this.analytics = analytics;
        this._namespace = _namespace;
        this.currentYear = new Date().getFullYear() + '';
        this.namespace = _namespace;
    }
    emailClick(event) {
        this.analytics.pushEvent('Contact_Email', {});
    }
    phoneClick(event) {
        this.analytics.pushEvent('Contact_Phone', {});
    }
}
GlobalFooterComponent.ɵfac = function GlobalFooterComponent_Factory(t) { return new (t || GlobalFooterComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.AnalyticsService), ɵngcc0.ɵɵdirectiveInject(NAMESPACE_TOKEN)); };
GlobalFooterComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: GlobalFooterComponent, selectors: [["global-footer"]], decls: 9, vars: 21, consts: [[3, "innerHTML"]], template: function GlobalFooterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵpipe(2, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(3, "div", 0);
        ɵngcc0.ɵɵpipe(4, "translate");
        ɵngcc0.ɵɵpipe(5, "translate");
        ɵngcc0.ɵɵpipe(6, "translate");
        ɵngcc0.ɵɵpipe(7, "translate");
        ɵngcc0.ɵɵpipe(8, "translate");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(2, 2, ctx.namespace + "GlobalFooter.Copyright", ɵngcc0.ɵɵpureFunction1(16, _c0, ctx.currentYear)));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("innerHTML", ɵngcc0.ɵɵpipeBind2(4, 5, ctx.namespace + "GlobalFooter.Contact", ɵngcc0.ɵɵpureFunction2(18, _c1, "<a href=\"mailto:" + ɵngcc0.ɵɵpipeBind1(5, 8, ctx.namespace + "GlobalFooter.EmailLink") + "\" (click)=\"emailClick()\" target=\"_blank\">" + ɵngcc0.ɵɵpipeBind1(6, 10, ctx.namespace + "GlobalFooter.EmailText") + "</a>", "<a href=\"tel:" + ɵngcc0.ɵɵpipeBind1(7, 12, ctx.namespace + "GlobalFooter.PhoneLink") + "\" (click)=\"phoneClick()\">" + ɵngcc0.ɵɵpipeBind1(8, 14, ctx.namespace + "GlobalFooter.PhoneText") + "</a>")), ɵngcc0.ɵɵsanitizeHtml);
    } }, dependencies: [ɵngcc2.TranslatePipe], styles: ["[_nghost-%COMP%]{color:var(--primary-text-color,#777);text-align:center}"] });
GlobalFooterComponent.ctorParameters = () => [
    { type: AnalyticsService },
    { type: undefined, decorators: [{ type: Inject, args: [NAMESPACE_TOKEN,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GlobalFooterComponent, [{
        type: Component,
        args: [{ selector: 'global-footer', template: "<div>{{ namespace + 'GlobalFooter.Copyright' | translate:{ currentYear: currentYear } }}</div>\n<div [innerHTML]=\"namespace + 'GlobalFooter.Contact' | translate:{\n  'email': '<a href=&quot;mailto:' + (namespace + 'GlobalFooter.EmailLink' | translate) + '&quot; (click)=&quot;emailClick()&quot; target=&quot;_blank&quot;>' + (namespace + 'GlobalFooter.EmailText' | translate) + '</a>',\n  'phone': '<a href=&quot;tel:' + (namespace + 'GlobalFooter.PhoneLink' | translate) + '&quot; (click)=&quot;phoneClick()&quot;>' + (namespace + 'GlobalFooter.PhoneText' | translate) + '</a>'\n}\"></div>\n", styles: [":host{color:var(--primary-text-color,#777);text-align:center}"] }]
    }], function () { return [{ type: ɵngcc1.AnalyticsService }, { type: undefined, decorators: [{
                type: Inject,
                args: [NAMESPACE_TOKEN]
            }] }]; }, null); })();
GlobalFooterComponent.ctorParameters = () => [
    { type: AnalyticsService },
    { type: undefined, decorators: [{ type: Inject, args: [NAMESPACE_TOKEN,] }] }
];

class GlobalFooterModule {
    static forRoot(config) {
        return {
            ngModule: GlobalFooterModule,
            providers: [
                { provide: NAMESPACE_TOKEN, useValue: config.namespace },
            ],
        };
    }
}
GlobalFooterModule.ɵfac = function GlobalFooterModule_Factory(t) { return new (t || GlobalFooterModule)(); };
GlobalFooterModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: GlobalFooterModule });
GlobalFooterModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        { provide: NAMESPACE_TOKEN, useValue: '' },
    ], imports: [CommonModule,
        TranslateModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GlobalFooterModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    TranslateModule,
                ],
                declarations: [
                    GlobalFooterComponent,
                ],
                exports: [
                    GlobalFooterComponent,
                ],
                providers: [
                    { provide: NAMESPACE_TOKEN, useValue: '' },
                ],
                schemas: [
                    CUSTOM_ELEMENTS_SCHEMA,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(GlobalFooterModule, { declarations: function () { return [GlobalFooterComponent]; }, imports: function () { return [CommonModule,
        TranslateModule]; }, exports: function () { return [GlobalFooterComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { GlobalFooterComponent, GlobalFooterModule, NAMESPACE_TOKEN as ɵa };

